module.exports = __webpack_public_path__ + "static/img/zdsys.9ce7431.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zdsys.png
// module id = gdsu
// module chunks = 78